import { Component, OnInit } from '@angular/core';
import { CertificateService } from 'src/app/features/proof-of-life/services/certificate-auth/certificate.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  constructor(private certificateService: CertificateService, private router: Router,private activeRoute: ActivatedRoute) { 
    this.createCertificateToken();
    
  }

  ngOnInit(): void {

  }

   createCertificateToken(){
    this.activeRoute.queryParams.subscribe(params => {
      this.certificateService.createCertificateToken(params['credential']).subscribe(res =>{
        sessionStorage.setItem('accessTokenJWT', res['accessToken']);
        sessionStorage.setItem('certificateExpiresIn', res['expiresIn']);
        if(sessionStorage.getItem('pathRedirect') !== null){
          this.router.navigate([sessionStorage.getItem('pathRedirect')]);
        }else{
          this.router.navigate(["/"]);
        }
      }, error =>{
        console.log(error,"Erro validacao certificado!")
        this.router.navigate(["/"]);
      });
    });
  }

}
